import { mesh } from 'topojson-client';
import landTopo from 'world-atlas/land-110m.json';
import { RADIUS } from '../constants';
import type { MorphBuffers } from '../types';
import { flat } from './flat';
import { sphere } from './sphere';

let cached: MorphBuffers | null = null;

function buildCoastlines(): MorphBuffers {
  const land = mesh(
    landTopo as never,
    (landTopo as unknown as { objects: { land: never } }).objects.land
  ) as unknown as { coordinates: [number, number][][] };
  const spherePos: number[] = [];
  const flatPos: number[] = [];
  for (const line of land.coordinates) {
    for (let i = 0; i < line.length - 1; i++) {
      const a = line[i];
      const b = line[i + 1];
      const wrapsAntimeridian = Math.abs(a[0] - b[0]) > 180;
      if (wrapsAntimeridian) continue;
      for (const [lon, lat] of [a, b]) {
        const p = sphere(lat, lon, RADIUS.coastline);
        spherePos.push(p.x, p.y, p.z);
        flatPos.push(...flat(lat, lon).toArray());
      }
    }
  }
  return {
    spherePos: new Float32Array(spherePos),
    flatPos: new Float32Array(flatPos),
  };
}

export function useCoastlines(): MorphBuffers {
  cached ??= buildCoastlines();
  return cached;
}
